"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var IosSwitchMaterialUi_1 = require("./IosSwitchMaterialUi");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return IosSwitchMaterialUi_1.default; } });
//# sourceMappingURL=index.js.map